import React from 'react';

export interface DesignerMetaContext {
    /* TODO: Remove this showResponsiveness prop once Prezi designers have better scores */
    hasMoreResultsUrl?: boolean;
}

export default React.createContext<DesignerMetaContext>({
    hasMoreResultsUrl: true,
});
